import { dracula } from "react-code-blocks";

const UpsunCodeTheme: typeof dracula = {
  ...dracula,
  commentColor: "#fff",
  keywordColor: "#8AE234",
  stringColor: "#34E2E2",
  quoteColor: "#34E2E2",
};
export default UpsunCodeTheme;
